import {io} from "socket.io-client";

export const socket = io("https://staging-socket.payper.ca", {
  autoConnect: false,
  transports: ['websocket'],
  upgrade: false,
});
